var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-loading",attrs:{"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.name)+" "),(_vm.loading)?_c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"spin-icon"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }